export default "__VITE_ASSET__Ci5ydRxY__"